<template>
  <v-card flat>
    <v-card-title>
      Forgwares playtests
    </v-card-title>
    <v-card-text>
      <div
        v-if="loading"
        class="pa-4 d-flex flex-column justify-center align-center"
      >
        <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="primary"
        />
        <div>Waiting for information for table</div>
      </div>
      <div v-else class="overflow-x-auto">
        <table class="users-table black--text caption">
          <thead>
            <tr>
              <th rowspan="3" class="sticky-col">
                Name
              </th>
              <th rowspan="3">
                Steam
              </th>
              <th class="text-no-wrap px-2" colspan="7" v-for="preset in presets" :key="preset">
                {{ preset }}
              </th>
            </tr>
            <tr>
              <template v-for="preset in presets">
                <th rowspan="2" :key="preset + '-session'" class="px-2">
                  Sessions
                </th>
                <th colspan="3" :key="preset + '-playtime'" class="px-2">
                  Playtime
                </th>
                <th colspan="3" :key="preset + '-distance'" class="px-2">
                  Distance
                </th>
              </template>
            </tr>
            <tr>
              <template v-for="preset in presets">
                <th :key="preset + '-playtime-avg'" class="px-2">
                  Avg
                </th>
                <th :key="preset + '-playtime-max'" class="px-2">
                  Max
                </th>
                <th :key="preset + '-playtime-min'" class="px-2">
                  Min
                </th>
                <th :key="preset + '-disatnce-avg'" class="px-2">
                  Avg
                </th>
                <th :key="preset + '-disatnce-max'" class="px-2">
                  Max
                </th>
                <th :key="preset + '-disatnce-min'" class="px-2">
                  Min
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.name">
              <td  class="text-no-wrap sticky-col px-2">
                {{ user.name }}
              </td>
              <td class="px-2">
                <a target="_blank" :href="user.steamProfileUrl">{{ user.steamDisplayName }}</a>
              </td>
              <template v-for="preset in presets" >
                <template v-if="user[preset].playtime.comment">
                  <td :key="user.name + '-' + preset + '-no-plyatime'" class="text-center" colspan="4">
                    {{ user[preset].playtime.comment }}
                  </td>
                </template>
                <template v-else>
                  <td :key="user.name + '-' + preset + '-sessions'" class="text-center">
                    {{ user[preset].playtime.sessions }}
                  </td>
                  <td :key="user.name + '-' + preset + '-palytime-avg'" class="text-center px-2">
                    {{ timeToString(user[preset].playtime.avg) }}
                  </td>
                  <td :key="user.name + '-' + preset + '-palytime-max'" class="text-center px-2">
                    {{ timeToString(user[preset].playtime.max) }}
                  </td>
                  <td :key="user.name + '-' + preset + '-palytime-min'" class="text-center px-2">
                    {{ timeToString(user[preset].playtime.min) }}
                  </td>
                </template>
                <template v-if="user[preset].distance.comment">
                  <td :key="user.name + '-' + preset + '-no-distance'" class="text-center" colspan="3">
                    {{ user[preset].distance.comment }}
                  </td>
                </template>
                <template v-else>
                  <td :key="user.name + '-' + preset + '-distance-avg'" class="text-center px-2">
                    {{ (user[preset].distance[0] / user[preset].distance[3]).toFixed(2) }}
                  </td>
                  <td :key="user.name + '-' + preset + '-distance-max'" class="text-center px-2">
                    {{ user[preset].distance[1].toFixed(2) }}
                  </td>
                  <td :key="user.name + '-' + preset + '-distance-min'" class="text-center px-2">
                    {{ user[preset].distance[2].toFixed(2) }}
                  </td>
                </template>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: false,
      headers: [],
      users: [],
      presets: []
    }
  },
  async mounted () {
    await this.getUsers()
  },
  methods: {
    async getUsers () {
      this.loading = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/telemetry/frogwares-playtests')
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.users = data.users
        this.presets = data.presets
      }
      this.loading = false
    },
  }
}
</script>

<style lang="css" scoped>
  .users-table {
    border-collapse: collapse;
  }
  .users-table th,
  .users-table td {
    border: 1px solid black;
  }
  .sticky-col {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 1;
  }
</style>